(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var mode = bar.getAttribute('data-animation');

      if (mode === 'marquee') {
        // Duplicate the track content so the loop is seamless.
        var track = bar.querySelector('[data-announcement-marquee]');
        if (track && !track.dataset.cloned) {
          track.innerHTML += track.innerHTML;
          track.dataset.cloned = 'true';
        }
        return;
      }

      var messages = bar.querySelectorAll('[data-announcement-msg]');
      if (messages.length < 2) return;
      if (bar.getAttribute('data-autoplay') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var styles = getComputedStyle(bar);
      var seconds = parseFloat(styles.getPropertyValue('--announcement-cycle')) || 4;
      var index = 0;

      var timer = setInterval(function () {
        messages[index].classList.remove('is-active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('is-active');
      }, seconds * 1000);

      /* Редактор тем пере-рендерит секции — интервал без снятия копится */
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target && e.target.contains(bar)) clearInterval(timer);
      });
    });
  })();

  /* Country/region disclosure: flag glyphs + accessible listbox. */
  (function () {
    function flagFor(iso) {
      return (iso || '').trim().toUpperCase().replace(/[A-Z]/g, function (c) {
        return String.fromCodePoint(0x1f1e6 - 65 + c.charCodeAt(0));
      });
    }

    document.querySelectorAll('.announcement [data-flag]').forEach(function (el) {
      el.textContent = flagFor(el.getAttribute('data-flag'));
    });

    document.querySelectorAll('.announcement [data-loc]').forEach(function (root) {
      var form = root.querySelector('form');
      var nativeSel = root.querySelector('[data-loc-native]');
      var trigger = root.querySelector('[data-loc-trigger]');
      var list = root.querySelector('[data-loc-list]');

      if (nativeSel && form) {
        nativeSel.addEventListener('change', function () { form.submit(); });
      }
      if (!form || !trigger || !list) return;

      var options = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
      if (!options.length) return;

      /* Portal the list to <body>: the bar (and other ancestors) create
         stacking contexts that can trap it behind page content. All its
         styles are global classes, and it is position:fixed, so moving it
         changes nothing except guaranteeing it paints on top.
         Portalled nodes outlive their section, so drop any orphan left by an
         earlier init of the same section (theme editor re-renders) and remove
         ours when the section unloads. */
      var locOwner = root.getAttribute('data-loc') || 'default';
      Array.prototype.forEach.call(
        document.querySelectorAll('body > [data-loc-list][data-loc-owner="' + locOwner + '"]'),
        function (orphan) { if (orphan !== list) orphan.remove(); }
      );
      list.setAttribute('data-loc-owner', locOwner);
      document.body.appendChild(list);

      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target && e.target.contains(root) && list.parentNode === document.body) list.remove();
      });

      var focusIdx = 0;
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute('aria-selected') === 'true') { focusIdx = i; break; }
      }

      function position() {
        var r = trigger.getBoundingClientRect();
        var right = window.innerWidth - r.right;
        if (right < 12) right = 12;
        list.style.top = (r.bottom + 6) + 'px';
        list.style.left = 'auto';
        list.style.right = right + 'px';
      }

      function setFocus(i) {
        focusIdx = (i + options.length) % options.length;
        for (var j = 0; j < options.length; j++) {
          options[j].classList.toggle('is-focused', j === focusIdx);
        }
        options[focusIdx].scrollIntoView({ block: 'nearest' });
      }

      function onDocClick(e) { if (!root.contains(e.target) && !list.contains(e.target)) close(); }

      /* Close on page scroll only. Element scrolls — the list's own scrollbar
         and the scrollIntoView we trigger on open — arrive with the element as
         target and must not dismiss the dropdown; page scrolls arrive with
         target=document. */
      function onScroll(e) {
        if (e.target !== document) return;
        close();
      }

      function open() {
        list.hidden = false;
        position();
        trigger.setAttribute('aria-expanded', 'true');
        setFocus(focusIdx);
        list.focus();
        document.addEventListener('click', onDocClick, true);
        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('resize', close);
      }

      function close() {
        if (list.hidden) return;
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onDocClick, true);
        window.removeEventListener('scroll', onScroll, true);
        window.removeEventListener('resize', close);
      }

      function choose(opt) {
        if (!opt) return;
        if (nativeSel) nativeSel.value = opt.getAttribute('data-value');
        form.submit();
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (list.hidden) { open(); } else { close(); }
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      });

      list.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); trigger.focus(); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); setFocus(focusIdx + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setFocus(focusIdx - 1); }
        else if (e.key === 'Home') { e.preventDefault(); setFocus(0); }
        else if (e.key === 'End') { e.preventDefault(); setFocus(options.length - 1); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(options[focusIdx]); }
      });

      options.forEach(function (opt) {
        opt.addEventListener('click', function () { choose(opt); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    var SELECTOR = '.jrnl .reveal';

    function reveal(scope) {
      var items = (scope || document).querySelectorAll(SELECTOR + ':not(.is-in)');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      items.forEach(function (el) { io.observe(el); });

      // Failsafe: ревил не должен оставить блок невидимым (observer промахнулся,
      // вкладка восстановлена в фоне, нестандартный вьюпорт) — форс через 2.5 с
      window.setTimeout(function () {
        (scope || document).querySelectorAll(SELECTOR + ':not(.is-in)').forEach(function (el) {
          el.classList.add('is-in');
        });
      }, 2500);
    }

    function init() { reveal(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var brace = String.fromCharCode(123);
      var amountToken = '$' + brace + brace + 'amount' + '}' + '}';
      var fmt = format || amountToken;
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;

      function withDelimiters(number, precision, thousands, decimal) {
        precision = isNaN(precision) ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';
        if (isNaN(number) || number == null) {
          return '0';
        }
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents2 = parts[1] ? decimal + parts[1] : '';
        /* как money_without_trailing_zeros на сервере: «$399», но «$399.50» */
        if (/^\D0+$/.test(cents2)) {
          cents2 = '';
        }
        return dollars + cents2;
      }

      var match = fmt.match(placeholder);
      var type = match ? match[1] : 'amount';
      var value = '';
      switch (type) {
        case 'amount':
          value = withDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = withDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_with_space_separator':
          value = withDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(cents, 0, ' ', '');
          break;
        default:
          value = withDelimiters(cents, 2);
      }
      return fmt.replace(placeholder, value);
    }

    function parseJSON(el) {
      if (!el) return {};
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return {};
      }
    }

    function cardState(card) {
      var checkbox = card.querySelector('[data-clook-check]');
      var sizeEl = card.querySelector('[data-clook-size]');
      var checked = checkbox ? checkbox.checked : true;
      var variantId = '';
      var price = 0;
      var compare = 0;
      var hasSelection = false;

      if (sizeEl) {
        if (sizeEl.tagName === 'SELECT') {
          var opt = sizeEl.options[sizeEl.selectedIndex];
          variantId = sizeEl.value;
          hasSelection = variantId !== '';
          if (opt) {
            price = parseInt(opt.getAttribute('data-price'), 10) || 0;
            compare = parseInt(opt.getAttribute('data-compare'), 10) || price;
          }
        } else {
          variantId = sizeEl.value;
          hasSelection = variantId !== '';
          price = parseInt(sizeEl.getAttribute('data-price'), 10) || 0;
          compare = parseInt(sizeEl.getAttribute('data-compare'), 10) || price;
        }
      }
      return {
        checked: checked,
        variantId: variantId,
        price: price,
        compare: compare,
        hasSelection: hasSelection
      };
    }

    function updateCardPrice(card, fmt) {
      var st = cardState(card);
      if (!st.hasSelection) return;
      var nowEl = card.querySelector('[data-clook-now]');
      var wasEl = card.querySelector('[data-clook-was]');
      var priceWrap = card.querySelector('.clook-card__price');
      if (nowEl) nowEl.textContent = money(st.price, fmt);
      if (st.compare > st.price) {
        if (wasEl) {
          wasEl.textContent = money(st.compare, fmt);
          wasEl.hidden = false;
        }
        if (priceWrap) priceWrap.classList.add('is-sale');
      } else {
        if (wasEl) wasEl.hidden = true;
        if (priceWrap) priceWrap.classList.remove('is-sale');
      }
    }

    function recompute(root) {
      var cards = root.querySelectorAll('[data-clook-card]');
      var total = 0;
      var compare = 0;
      var count = 0;
      cards.forEach(function (card) {
        var st = cardState(card);
        if (!st.checked) return;
        count += 1;
        total += st.price;
        compare += st.compare;
      });
      var save = compare - total;
      var fmt = root.getAttribute('data-money-format');
      var strings = parseJSON(root.querySelector('[data-clook-strings]'));

      var totalEl = root.querySelector('[data-clook-total]');
      var countEl = root.querySelector('[data-clook-count]');
      var saveEl = root.querySelector('[data-clook-save]');
      var saveAmt = root.querySelector('[data-clook-save-amount]');
      if (totalEl) totalEl.textContent = money(total, fmt);
      if (countEl) countEl.textContent = count;
      if (saveEl && saveAmt) {
        if (strings.showSavings && save > 0) {
          saveAmt.textContent = money(save, fmt);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function showError(root, msg) {
      var box = root.querySelector('[data-clook-error]');
      if (!box) return;
      box.textContent = msg || '';
      box.hidden = !msg;
    }

    function addBundle(root) {
      var strings = parseJSON(root.querySelector('[data-clook-strings]'));
      var requireSize = root.getAttribute('data-require-size') === 'true';
      var cards = root.querySelectorAll('[data-clook-card]');
      var items = [];
      var missing = false;

      cards.forEach(function (card) {
        card.classList.remove('is-invalid');
      });

      cards.forEach(function (card) {
        var st = cardState(card);
        if (!st.checked) return;
        if (requireSize && !st.hasSelection) {
          missing = true;
          card.classList.add('is-invalid');
          return;
        }
        if (st.variantId) {
          items.push({ id: st.variantId, quantity: 1 });
        }
      });

      if (missing) {
        showError(root, strings.requireSizeMsg || 'Please choose a size for each selected item.');
        var firstBad = root.querySelector('.clook-card.is-invalid [data-clook-size]');
        if (firstBad && firstBad.focus) firstBad.focus();
        return;
      }
      if (items.length === 0) {
        showError(root, strings.emptyMsg || 'Select at least one item to add.');
        return;
      }

      showError(root, '');
      root.classList.add('is-busy');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (d) {
              throw new Error(d.description || d.message || 'Add to cart failed');
            });
          }
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (err) {
          showError(root, (err && err.message) || strings.genericErrorMsg || 'Something went wrong. Please try again.');
        })
        .finally(function () {
          root.classList.remove('is-busy');
        });
    }

    function initRoot(root) {
      if (root.dataset.clookReady === 'true') return;
      root.dataset.clookReady = 'true';
      var fmt = root.getAttribute('data-money-format');

      root.addEventListener('change', function (e) {
        var card = e.target.closest('[data-clook-card]');
        if (card && e.target.matches('[data-clook-size]')) {
          updateCardPrice(card, fmt);
        }
        recompute(root);
      });

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-clook-add]')) {
          e.preventDefault();
          addBundle(root);
        }
      });

      recompute(root);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-clook-root]');
      roots.forEach(initRoot);
    }

    if (document.readyState !== 'loading') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.editorial.reveal';

    function reveal(scope) {
      var items = (scope || document).querySelectorAll(SELECTOR + ':not(.is-in)');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      items.forEach(function (el) { io.observe(el); });

      // Failsafe: ревил не должен оставить блок невидимым (observer промахнулся,
      // вкладка восстановлена в фоне, нестандартный вьюпорт) — форс через 2.5 с
      window.setTimeout(function () {
        (scope || document).querySelectorAll(SELECTOR + ':not(.is-in)').forEach(function (el) {
          el.classList.add('is-in');
        });
      }, 2500);
    }

    function init() { reveal(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-run when a section is (re)rendered inside the Theme Editor.
    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selects = document.querySelectorAll('[data-loc-select]');
    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', function () {
        var form = this.closest('form');
        if (form) form.submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-header]').forEach(function (header) {
      var section = header.closest('.shopify-section') || document;
      var coarse = window.matchMedia ? window.matchMedia('(hover: none)') : { matches: false };

      /* ---- Mobile drawer ---- */
      var openBtn = header.querySelector('[data-drawer-open]');
      var drawer = section.querySelector('[data-drawer]');
      var overlay = section.querySelector('[data-drawer-overlay]');
      var closeBtn = drawer ? drawer.querySelector('[data-drawer-close]') : null;
      var lastFocus = null;
      var hideTimer = null;

      function openDrawer() {
        if (!drawer) return;
        if (hideTimer) {
          window.clearTimeout(hideTimer);
          hideTimer = null;
        }
        lastFocus = document.activeElement;
        drawer.hidden = false;
        if (overlay) overlay.hidden = false;
        requestAnimationFrame(function () {
          drawer.setAttribute('data-open', '');
          if (overlay) overlay.setAttribute('data-open', '');
        });
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.removeAttribute('data-open');
        if (overlay) overlay.removeAttribute('data-open');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        hideTimer = window.setTimeout(function () {
          hideTimer = null;
          drawer.hidden = true;
          if (overlay) overlay.hidden = true;
        }, 300);
        if (lastFocus) lastFocus.focus();
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      /* ---- Mega menus — one panel per mega parent ---- */
      var megaParents = header.querySelectorAll('[data-mega-parent]');

      function closeAllMegas(except) {
        megaParents.forEach(function (p) {
          if (p === except) return;
          p.removeAttribute('data-open');
          var t = p.querySelector('[data-mega-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }

      megaParents.forEach(function (parent) {
        var toggle = parent.querySelector('[data-mega-toggle]');
        var link = parent.querySelector('[data-mega-link]');

        function openMega() {
          closeAllMegas(parent);
          parent.setAttribute('data-open', '');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
        function closeMega() {
          parent.removeAttribute('data-open');
          parent.classList.remove('esc-closed');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }

        /* Chevron toggle (touch affordance / a11y). */
        if (toggle) {
          toggle.addEventListener('click', function () {
            if (parent.hasAttribute('data-open')) {
              closeMega();
            } else {
              openMega();
            }
          });
        }

        /* Touch: first tap on the label opens the mega, second tap navigates. */
        if (link) {
          link.addEventListener('click', function (event) {
            if (!coarse.matches) return;
            if (!parent.hasAttribute('data-open')) {
              event.preventDefault();
              openMega();
            }
          });
        }

        /* Close when focus leaves the item (keyboard). */
        parent.addEventListener('focusout', function (event) {
          if (!parent.contains(event.relatedTarget)) closeMega();
        });

        parent._closeMega = closeMega;
      });

      /* Tap outside any mega closes open ones (touch). */
      document.addEventListener('click', function (event) {
        if (header.contains(event.target)) return;
        closeAllMegas(null);
      });

      /* ---- Escape closes everything ---- */
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (drawer && drawer.hasAttribute('data-open')) closeDrawer();
        megaParents.forEach(function (parent) {
          if (parent._closeMega) parent._closeMega();
        });
        /* Мега, открытая с клавиатуры, держится на :focus-within — одного
           снятия data-open мало. Подавляем панель и возвращаем фокус
           на верхнюю ссылку пункта; focusout снимет подавление. */
        if (event.target instanceof Element) {
          var mp = event.target.closest('[data-mega-parent]');
          if (mp) {
            mp.classList.add('esc-closed');
            var focusTo = mp.querySelector('[data-mega-link], [data-mega-toggle]');
            if (focusTo) focusTo.focus();
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ig-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.iggrid-sec .reveal';

    function reveal(scope) {
      var items = (scope || document).querySelectorAll(SELECTOR + ':not(.is-in)');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });

      // Failsafe: ревил не должен оставить блок невидимым (observer промахнулся,
      // вкладка восстановлена в фоне, нестандартный вьюпорт) — форс через 2.5 с
      window.setTimeout(function () {
        (scope || document).querySelectorAll(SELECTOR + ':not(.is-in)').forEach(function (el) {
          el.classList.add('is-in');
        });
      }, 2500);
    }

    function init() { reveal(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-run when a section is (re)rendered inside the Theme Editor.
    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-account]');
    if (!root) return;
    var buttons = root.querySelectorAll('[data-pane-btn]');
    var panes = root.querySelectorAll('[data-pane]');

    function activate(name) {
      panes.forEach(function (pane) {
        pane.hidden = pane.getAttribute('data-pane') !== name;
      });
      buttons.forEach(function (btn) {
        var on = btn.getAttribute('data-pane-btn') === name;
        btn.classList.toggle('is-active', on);
        if (on) { btn.setAttribute('aria-current', 'true'); }
        else { btn.removeAttribute('aria-current'); }
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-pane-btn'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-addresses]');
    if (!root) return;

    var forms = root.querySelectorAll('[data-address-form]');

    root.querySelectorAll('select[data-default]').forEach(function (select) {
      var value = select.getAttribute('data-default');
      if (value) select.value = value;
    });

    function closeAll() {
      forms.forEach(function (f) { f.hidden = true; });
    }

    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-address-toggle]');
      if (toggle) {
        var id = toggle.getAttribute('data-address-toggle');
        var target = root.querySelector('[data-address-form="' + id + '"]');
        var wasOpen = target && !target.hidden;
        closeAll();
        if (target && !wasOpen) {
          target.hidden = false;
          var focusEl = target.querySelector('input, select');
          if (focusEl) focusEl.focus();
          target.scrollIntoView({ block: 'nearest' });
        }
        return;
      }

      if (event.target.closest('[data-address-cancel]')) {
        closeAll();
        return;
      }

      var del = event.target.closest('[data-address-delete]');
      if (del) {
        var message = del.getAttribute('data-confirm');
        if (!message || window.confirm(message)) {
          var form = document.createElement('form');
          form.method = 'post';
          form.action = del.getAttribute('data-address-delete');
          var method = document.createElement('input');
          method.type = 'hidden';
          method.name = '_method';
          method.value = 'delete';
          form.appendChild(method);
          document.body.appendChild(form);
          form.submit();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-login]');
    if (!root) return;
    var loginView = root.querySelector('[data-login-view]');
    var recoverView = root.querySelector('[data-recover-view]');
    if (!loginView || !recoverView) return;

    function show(which) {
      var recover = which === 'recover';
      recoverView.hidden = !recover;
      loginView.hidden = recover;
      var focusEl = (recover ? recoverView : loginView).querySelector('input, button');
      if (focusEl) focusEl.focus();
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-recover-open]')) {
        event.preventDefault();
        show('recover');
      } else if (event.target.closest('[data-login-open]')) {
        event.preventDefault();
        show('login');
      }
    });

    if (window.location.hash === '#recover' || recoverView.querySelector('[data-recover-flag]')) {
      recoverView.hidden = false;
      loginView.hidden = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
    (function () {
      // Single runtime source of truth (mirrors snippets/utility-product-check.liquid):
      // handle starts with "__" OR vendor is "re:do" → utility, never listed.
      window.viossiIsUtilityProduct = window.viossiIsUtilityProduct || function (handle, vendor) {
        var h = String(handle == null ? '' : handle).toLowerCase();
        var v = String(vendor == null ? '' : vendor).toLowerCase();
        return h.indexOf('__') === 0 || v === 're:do' || h === 'navidium-shipping-protection';
      };

      var KEY = 'viossi:recently-viewed';
      var CAP = 12;
      var root = document.querySelector('[data-recently-viewed]');
      if (!root) return;

      var snapEl = root.querySelector('[data-recently-current]');
      var grid = root.querySelector('#recentlyViewedGrid');
      if (!snapEl || !grid) return;

      var current;
      try { current = JSON.parse(snapEl.textContent || '{}'); } catch (e) { current = null; }

      function read() {
        try {
          var raw = window.localStorage.getItem(KEY);
          var arr = raw ? JSON.parse(raw) : [];
          return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
      }
      function write(arr) {
        try { window.localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
      }

      var history = read();

      // Never remember utility/service products, even if this PDP is one.
      var currentIsUtility = current && window.viossiIsUtilityProduct(current.handle, current.vendor);

      // Push the current product to the front (deduped by handle), then persist.
      if (current && current.handle && !currentIsUtility) {
        history = history.filter(function (p) { return p && p.handle !== current.handle; });
        history.unshift(current);
        if (history.length > CAP) history = history.slice(0, CAP);
        write(history);
      }

      // Render everything except the product being viewed and any utility product
      // that may already be sitting in an older localStorage history.
      var max = parseInt(root.getAttribute('data-max'), 10) || 4;
      var others = history.filter(function (p) {
        return p && p.handle && (!current || p.handle !== current.handle) && p.url &&
          !window.viossiIsUtilityProduct(p.handle, p.vendor);
      }).slice(0, max);

      if (!others.length) return;

      function esc(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;')
          .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }

      grid.innerHTML = others.map(function (p) {
        var media = p.img
          ? '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.title) + '">'
          : '';
        var priceBits = '<span class="rv-now">' + esc(p.price) + '</span>';
        if (p.compare) priceBits += ' <s class="rv-was">' + esc(p.compare) + '</s>';
        // Badges come precomputed in the snapshot (see the Liquid block above);
        // entries stored before that shipped simply have none. The class is
        // whitelisted here so localStorage can never inject markup or CSS.
        var badges = '';
        if (p.badges && p.badges.length) {
          badges = '<div class="rv-badges">' + p.badges.map(function (b) {
            if (!b || !b.label) return '';
            var cls = b.cls === 'sale' ? 'sale' : b.cls === 'new' ? 'new' : 'best';
            return '<span class="badge badge--' + cls + '">' + esc(b.label) + '</span>';
          }).join('') + '</div>';
        }
        return '<article class="rv-card">' +
            '<a class="rv-media" href="' + esc(p.url) + '">' + media + badges + '</a>' +
            '<div class="rv-body">' +
              '<a class="rv-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<div class="rv-price">' + priceBits + '</div>' +
            '</div>' +
          '</article>';
      }).join('');

      root.hidden = false;
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.reviews .reveal';

    function showAll(items) {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }

    function reveal(scope) {
      var items = (scope || document).querySelectorAll(SELECTOR + ':not(.is-in)');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        showAll(items);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px 15% 0px' });
      items.forEach(function (el) { io.observe(el); });

      // Failsafe: the reveal cloak (opacity:0) must never leave the section
      // looking empty. If a card hasn't been revealed shortly after load —
      // observer missed it, tab restored in background, odd viewport — force it.
      window.setTimeout(function () {
        showAll((scope || document).querySelectorAll(SELECTOR + ':not(.is-in)'));
      }, 2500);
    }

    function init() { reveal(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-run when a section is (re)rendered inside the Theme Editor.
    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
